import(/* webpackMode: "eager" */ "/app/apps/frontend/src/app/global-error.tsx");
